import { useLayoutEffect, useRef } from "react";

import NavBar from "../../components/fragments/NavBar";
import Footer from "../../components/fragments/Footer";
import useGuideInteractions from "../../hooks/useGuideInteractions";
import { useStaticSeo } from "../../hooks/useSeo";
import { STATIC_SEO } from "../../data/seo";
import { SALES_GUIDE_CONTENT } from "../../data/guides/salesGuideContent";

// The stylesheet is written once, shared with LettingsGuide.js, and scopes
// every selector under .guide-page - see the file header there for why that
// matters. Importing it here (rather than in index.css) means it only ever
// reaches the DOM while one of these two pages is mounted.
import "./guideStyles.css";

/**
 * Renders the supplied sales-guide page inside the site's own NavBar/Footer.
 * The bulk of the markup is static marketing content (fee tables, an FAQ
 * accordion via native <details>, testimonials) injected via
 * dangerouslySetInnerHTML, the same technique SingleBlog.js already uses for
 * post.content - hand-converting ~500 lines of largely inert HTML to JSX
 * component-by-component would only add a much larger surface for
 * transcription mistakes. useGuideInteractions wires up the one piece of
 * real behaviour that content needs (the scroll-reveal fade-in).
 */
export default function SalesGuide() {
    useStaticSeo(STATIC_SEO["/sales-guide"]);
    useLayoutEffect(() => {
        document.getElementById("root").scrollTo(0, 0);
    }, []);

    const containerRef = useRef(null);
    useGuideInteractions(containerRef);

    return (
        <>
            <NavBar location="public" pageTitle="Sales" />
            <div
                className="guide-page sales"
                ref={containerRef}
                dangerouslySetInnerHTML={{ __html: SALES_GUIDE_CONTENT }}
            />
            <Footer />
        </>
    );
}
